import { render, staticRenderFns } from "./m-login.vue?vue&type=template&id=2b6e9afc&scoped=true&"
import script from "./m-login.vue?vue&type=script&lang=js&"
export * from "./m-login.vue?vue&type=script&lang=js&"
import style0 from "./m-login.vue?vue&type=style&index=0&id=2b6e9afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6e9afc",
  null
  
)

export default component.exports